<template>
  <main class="w-screen h-screen overflow-x-auto">
    <section
      id="scrollableContent"
      :class="[
        'relative w-full min-w-[1500px] h-full overflow-y-auto overflow-x-auto bg-[#FCFCFD]',
      ]"
    >
      <app-navbar />
      <div v-show="showClosedProject" class="mx-[0.8rem] mt-4 mb-5">
        <display-closed-project></display-closed-project>
      </div>
      <ContractTerminated v-show="contractTerminated" />
      <!-- @slot Use this slot to display dashboard content -->
      <div :class="getCSSText">
        <router-view :key="$route.fullPath"></router-view>
      </div>
    </section>
  </main>
</template>

<script lang="js">
import { defineComponent } from "vue";
import AppNavbar from "@/components/shared/AppNavbar.vue";
import DisplayClosedProject from "@/components/dashboard/projects/DisplayClosedProject.vue";
import ContractTerminated from "../dashboard/employees/ContractTerminated.vue";
export default defineComponent({
  name: "Dashboard Layout",
  components: {
    AppNavbar,
    DisplayClosedProject,
    ContractTerminated
  },
  data(){
    return{

    }
  },
  computed:{
    showClosedProject(){
      const closedProject = this.$store.getters["projectModules/isCurrentProject"]
      const checkStatus = this.$route.path=== "/edit-project" && closedProject.project_status === 'Closed'
      if(checkStatus){
        this.$store.commit("hrResources/SET_SHOW_EDIT_BUTTON_TO_STATE", false);
      }
      return  checkStatus
    },
    contractTerminated(){
      const terminated = this.$store.getters["hrResources/isPersonalData"];
      return this.$route.path === '/edit-employee' && terminated?.is_terminated
    },
    currentPath() {
      return this.$route.path;
    },
    getCSSText() {
      if (![
        "/edit-project",
        "/edit-expert",
        "/edit-employment-contract",
        "/add-project",
        "/home",
        "/edit-order",
        "/edit-mission-forms",
        "/edit-employee",
        "/project-configuration",
        "/setting-templates",
        "/edit-entity",
        "/jobbase",
        "/view-establishment-details",
        "/add-project",
        "/add-employee",
        "/leaves",
        "/edit-my-team-employee",
        "/edit-pm-local"
      ].some((path) => this.currentPath.includes(path))) {
        return "mx-8 mt-7"
      }
      return ""
    }
  },
});
</script>
